import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(public router: Router, private toastr: ToastrService,) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(error => {
        console.error("error is intercept", error.status);
        if (error.status == 400)
        this.toastr.error(
          'الرجاء التثبت من المعطيات',
          ' يرجى التحقق ',
        )
        else if (error.status == 500) 
        this.toastr.error(
          'حدث خطأ',
        )
        else if (error.status == 401 || error.status == 403) { return throwError(null) }
        else this.toastr.error(
          error?.error?.message,
        )
        return throwError(error);
      })
    );
  }
}